<template>
    <div id="oppreg-qa">
        <strong>NOTE: All fields with <span class="required">*</span> are required</strong>
        <div class="pricing-tier-overview-container">
            <div class="my-2 px-2 py-1 black">
            <label class="font-weight-bold white--text">Pricing Tiers Overview [<a href="#" @click="downloadGuide" >Download Oppreg Guide for more details</a>] </label>
            </div>
            <p>DXC’s approved discounts for AWS Services are indexed to AWS Public/Published Pricing</p>
            <ul>
            <li><a href="#" @click="downloadGuide" ><u>Download Oppreg Guide</u></a> for discount details. Note the public sector SPP qualifications in the OppReg guide.</li>
            <li>Solution Provider Program (SPP) – up to 12% discount (with new account ID) for the first 2 years and 7% thereafter. </li>
            <li>Private Pricing Agreement (PPA) – 23% discount for qualified workloads.</li>
            <li>View the OppReg guide download for pricing tier details. </li>
            </ul>
        </div>
        <v-layout
            row
            wrap
        >
            <v-flex md12>
            <div class="my-2 px-2 py-1 black">
                <label class="font-weight-bold white--text">Pricing Tier Qualification</label>
            </div>
            <div class="my-2">
                <label>Answer the following questions to determine the applicable Pricing Tier – final tier approval will be provided by Galaxy email to you upon AWS approval. </label>
            </div>
            <v-layout align-center>
                <v-flex md9>
                <label class="mr-3">8.Will the client require access to DXC’s AWS login credentials, the AWS Management Console or AWS resources, e.g. S3 storage or EC2 instances? If YES, then workload qualifies for SPP and there is no need for questions 9 and 10. <span class="required">*</span></label>
                </v-flex>
                <v-flex md3 class="text-md-center">
                <v-btn-toggle v-model="workloadForm.fields.Q8" @change="determineWorkloadType">
                    <v-btn
                    :disabled="type==='view'"
                    :class="{ 'v-btn--active': workloadForm.fields.Q8 === 'Y' }"
                    value="Y"
                    class="black--text btn--qa">Yes</v-btn>
                    <v-btn
                    :disabled="type==='view'"
                    :class="{ 'v-btn--active': workloadForm.fields.Q8 === 'N' }"
                    value="N"
                    class="black--text btn--qa">No</v-btn>
                </v-btn-toggle>
                </v-flex>
            </v-layout>
            <v-layout align-center v-if="workloadForm.fields.Q8 == 'Y'">
                <v-flex md9>
                <div class="px-2 py-1 black text-md-right">
                    <label class="font-weight-bold white--text">Your response qualifies the workload for:</label>
                </div>
                </v-flex>
                <v-flex md3>
                <div class="d-flex align-center">
                    <div class="text-md-center black px-2 py-1">
                    <span class="font-weight-bold white--text">SPP Pricing Tier</span>
                    </div>
                </div>
                </v-flex>
            </v-layout>
            <v-layout align-center style="position:relative">
                <div v-if="workloadForm.fields.Q8 == 'Y' || !workloadForm.fields.Q8" class="disabled-section"></div>
                <v-flex md9>
                <label class="mr-3">9. Will the AWS resources be used for a SaaS or PaaS solution delivered by DXC? If YES, then workload qualifies for PPA and there is no need for question 10.<span v-if="workloadForm.fields.Q7 == 'N'" class="required">*</span></label>
                </v-flex>
                <v-flex md3 class="text-md-center">
                <v-btn-toggle v-model="workloadForm.fields.Q9" @change="determineWorkloadType">
                    <v-btn
                    :disabled="type==='view'"
                    :class="{ 'v-btn--active': workloadForm.fields.Q9 === 'Y' }"
                    value="Y"
                    class="black--text btn--qa">Yes</v-btn>
                    <v-btn
                    :disabled="type==='view'"
                    :class="{ 'v-btn--active': workloadForm.fields.Q9 === 'N' }"
                    value="N"
                    class="black--text btn--qa">No</v-btn>
                </v-btn-toggle>
                </v-flex>
            </v-layout>
            <v-layout align-center style="position:relative" v-if="workloadForm.fields.Q9 == 'Y'">
                <div v-if="workloadForm.fields.Q8 == 'Y' || !workloadForm.fields.Q8" class="disabled-section"></div>
                <v-flex md9>
                <div class="px-2 py-1 black text-md-right">
                    <label class="font-weight-bold white--text">Your response qualifies the workload for:</label>
                </div>
                </v-flex>
                <v-flex md3>
                <div class="d-flex align-center">
                    <div class="text-md-center black px-2 py-1">
                    <span class="font-weight-bold white--text">PPA Pricing Tier</span>
                    </div>
                </div>
                </v-flex>
            </v-layout>
            <v-layout align-center style="position:relative">
                <div v-if="workloadForm.fields.Q8 == 'Y' || !workloadForm.fields.Q8  || workloadForm.fields.Q9 == 'Y' || !workloadForm.fields.Q9" class="disabled-section"></div>
                <v-flex md9>
                <label class="mr-3">10. For existing non-AWS workloads, has DXC been providing managed services for the workload(s) since September 1, 2018? If YES, then workload qualifies for PPA.<span v-if="workloadForm.fields.Q7 == 'N' && workloadForm.fields.Q8 == 'N'" class="required">*</span></label>
                </v-flex>
                <v-flex md3 class="text-md-center">
                <v-btn-toggle v-model="workloadForm.fields.Q10" @change="determineWorkloadType">
                    <v-btn
                    :disabled="type==='view'"
                    :class="{ 'v-btn--active': workloadForm.fields.Q10 === 'Y' }"
                    value="Y"
                    class="black--text btn--qa">Yes</v-btn>
                    <v-btn
                    :disabled="type==='view'"
                    :class="{ 'v-btn--active': workloadForm.fields.Q10 === 'N' }"
                    value="N"
                    class="black--text btn--qa">No</v-btn>
                </v-btn-toggle>
                </v-flex>
            </v-layout>
            <v-layout align-center style="position:relative" v-if="workloadForm.fields.Q10">
                <div v-if="workloadForm.fields.Q8 == 'Y' || !workloadForm.fields.Q8  || workloadForm.fields.Q9 == 'Y' || !workloadForm.fields.Q9" class="disabled-section"></div>
                <v-flex md9>
                <div class="px-2 py-1 black text-md-right">
                    <label class="font-weight-bold white--text">Your response qualifies the workload for:</label>
                </div>
                </v-flex>
                <v-flex md3>
                <div class="d-flex align-center black px-2 py-1">
                    <div class="font-weight-bold text-md-center white--text" v-if="workloadForm.fields.Q10 == 'Y'">
                    PPA Pricing Tier
                    </div>
                    <div class="font-weight-bold text-md-center white--text" v-if="workloadForm.fields.Q10 == 'N'">
                    SPP Pricing Tier
                    </div>
                </div>
                </v-flex>
            </v-layout>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'

export default {
    props: {
        type: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            attestedDateMenu: false,
        }
    },
    computed: {
        ...mapState('user/requestOppreg', ['workloadForm','workloadStep', 'oppType']),
        attestedDate: {
            get () {
                return window.moment(this.workloadForm.fields.Attested_By_Date).isValid()
                ? this.workloadForm.fields.Attested_By_Date
                : null
            },
            set (date) {
                this.workloadForm.fields.Attested_By_Date = date
            }
        },
    },
    methods: {
        ...mapMutations({
            setWorkloadType: 'user/requestOppreg/setWorkloadType',
        }),
        determineWorkloadType () {
            let workloadType
            if (this.workloadForm.fields.Q7 === 'Y') {
                workloadType = 'Transfer'
                this.clearDiscountAnswers()
            } else if (this.workloadForm.fields.Q8 === 'Y') {
                workloadType = 'SPP'
            } else if (this.workloadForm.fields.Q9 === 'Y') {
                workloadType = 'PPA'
            } else if (this.workloadForm.fields.Q10 === 'Y'){
                workloadType = 'PPA'
            } else if (this.workloadForm.fields.Q10 === 'N'){
                workloadType = 'SPP'
            }

            this.setWorkloadType(workloadType)
        },
        downloadGuide () {
            window.open(window.location.origin + '/DXC+AWS+Opportunity+Registration+Guide.pdf', '_blank').focus();
        },
    },
}
</script>
<style lang="scss" scoped>

#oppreg-qa {
    .disabled-section {
        background: #f5f5f5;
        width: 100%;
        position: absolute;
        right: 0px;
        top: 0px;
        z-index: 99;
        height: 100%;
        opacity: 0.7;
    }
    .pricing-tier-overview-container > p {
      border-bottom: 1px solid #000;
      font-size: 16px !important;
      color: #000;
    }

    header {
      background: #000;
      color: #fff;
      margin: 10px 10px;
      .container {
        padding: 0 25px;
      }
      .container span{
        font-weight: 600;
        text-decoration: underline;
      }
    }
    .workload-type {
      padding-top: 33px;
      padding-left: 10px;
    }
    .qa-form {
      .v-btn-toggle{ margin:10px 0}
      .v-btn-toggle .v-btn{
        padding: 15px 38px;
        opacity: 1;
      }
      
      .btn--qa{
        font-weight: bold !important;
      }

      .v-select--width{
        width: 100%;
      }

      span{
        &.workload-desc{
          font-weight:600
        }
      }
      div {
        &.qa-desc{
          font-style: italic;
          font-size: 14px;
        }
      }
      .input-symbol-dollar {
          position: relative;
          display: block;
        }
        .input-symbol-dollar:after {
            color: #37424a !important;
            content: "$";
            font-size: 16px !important;
            font-weight: 400;
            position: absolute;
            display: block;
            height: 100%;
            top: 0;
            left: 10px;
            line-height: 42px;
        }
        .padding-left-15.v-text-field input{
          padding-left:15px;
          background: yellow;
        }
        // .theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat){
        //   background-color: grey;
        // }
        .v-btn--active:before, .v-btn:focus:before, .v-btn:hover:before{
          background-color: grey;
        }
         .opp-btn {
          width: 200px;
        }
    }
}
    
</style>